




import { defineComponent } from "@vue/composition-api";
import Vue from "vue";
import EmptyContent from "@/components/EmptyContent";

Vue.component("EmptyContent", EmptyContent);
export default defineComponent({
  name: "MessageThreadsEmptyView",
});
